import "./peoplepage.css";
import data from "./peopleData.json";
import data2 from "./peopleData2.json";


//Cohort 1
import Corbin from './peoplePhotos/corbinprince.jpg'
import Josh from './peoplePhotos/joshspoor.jpg'
import Kendra from './peoplePhotos/kendraeller.jpg'
import Lily from './peoplePhotos/lilyhaley.jpg'
import Mercedes from './peoplePhotos/mercedessanders.jpg'
import Shelby from './peoplePhotos/shelbybrown.jpg'
import Twila from './peoplePhotos/twiladale.jpg'
import Tyler from './peoplePhotos/tylerpaine.jpg'
import Footer from '../BSUFooter/BSUFooter'

//Cohort 2
import Amanda from './peoplePhotos/AmandaEpping.jpg'
import Alexander from './peoplePhotos/AlexanderBell.jpg'
import Noah from './peoplePhotos/NoahOliver.jpg'
import Gabrielle from './peoplePhotos/GabrielleBennitt.jpg'
import Kayle from './peoplePhotos/KayleReyes.jpg'
import Eden from './peoplePhotos/EdenHammond.jpg'
import GroupPhoto from './peoplePhotos/2023and2024GroupPhoto.jpg'



function PeoplePage() {


  const people = [Shelby,Twila,Kendra,Lily,Tyler,Corbin,Mercedes,Josh]
  const people2 = [Alexander,Gabrielle,Amanda,Eden,Noah,Kayle]
  return (
    <div className="pageContainer">
      <div className="headerBanner">
        <h1 >Meet Our Scholars</h1>
        <h4><a href="https://digitalcorps.s3.amazonaws.com/csh-website-chemistry-scholarship/build/index.html">Home</a></h4>
      </div>


      <h1 style={{textAlign: "center", paddingBottom: 0}}>Cohort 2 - Fall 2024</h1>

        <div className="peopleContainer" style={{gap: '3rem'}}>
            {data2.map((person,i) => {
                console.log(person.name);
                return (
                <div className="personCard">
                    <div>
                      <img className="personPhoto" src={people2[i]} />
                    
                    </div>


                    <div className="personText">
                    
                      <h2>{person.name}</h2>

                      <p><b>{person.major}</b></p>
                      <p><b>Graduation Year:</b>  {person.degreeCompletionYear}</p>
                      <p><b>Faculty Mentor:</b> <a href={person.linkToFacultyMentor}>{person.facultyMentor}</a></p>
                    </div>

                </div>
                );
            })}
        </div>


        <h1 style={{textAlign: "center", paddingBottom: 0}}>Cohort 1 - Fall 2023</h1>

        <div className="peopleContainer">
            {data.map((person,i) => {
                console.log(person.name);
                return (
                <div className="personCard">
                    <div>
                      <img className="personPhoto" src={people[i]} />
                    
                    </div>


                    <div className="personText">
                    
                      <h2>{person.name}</h2>

                      <p><b>{person.major}</b></p>
                      <p><b>Graduation Year:</b>  {person.degreeCompletionYear}</p>
                      <p><b>Faculty Mentor:</b> <a href={person.linkToFacultyMentor}>{person.facultyMentor}</a></p>
                    </div>

                </div>
                );
            })}
        </div>
      
        <Footer />
    </div>
  );
}

export default PeoplePage;
